import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkle, X, PlayCircle } from '@phosphor-icons/react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter23 G5 — educational popup, Temu-style slide-up.
// Triggers after 30s of inactivity. Capped to 1 popup / 3 days / user.
const IDLE_MS = 30 * 1000;
const COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
const STORAGE_KEY = 'autospa5_edu_popup_last_shown';

const VIDEO_TEASERS = [
  { id: 'how_portal_works', title: 'Si funksionon portali HK-360Pro', cta: 'Shiko video', icon: '🚗' },
  { id: 'liquid_glass', title: 'Liquid Glass — para dhe pas', cta: 'Zbulo magjinë', icon: '✨' },
  { id: 'deep_detailing', title: 'Detailing i plotë — vlerë e shtuar', cta: 'Shiko procesin', icon: '🧹' },
];

export default function EduPopup() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    if (!user) return;
    // Cooldown check
    const lastShown = localStorage.getItem(STORAGE_KEY);
    if (lastShown && Date.now() - new Date(lastShown).getTime() < COOLDOWN_MS) return;

    let idleTimer;
    const reset = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        const pick = VIDEO_TEASERS[Math.floor(Math.random() * VIDEO_TEASERS.length)];
        setVideo(pick);
        setOpen(true);
        localStorage.setItem(STORAGE_KEY, new Date().toISOString());
      }, IDLE_MS);
    };
    const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];
    events.forEach((e) => window.addEventListener(e, reset));
    reset();
    return () => {
      clearTimeout(idleTimer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [user]);

  return (
    <AnimatePresence>
      {open && video && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 280, damping: 30 }}
          className="fixed left-4 right-4 bottom-20 z-[70]"
          data-testid="edu-popup"
        >
          <Link to="/zbulo" onClick={() => setOpen(false)}
                className="block p-3 rounded-2xl bg-gradient-to-br from-[#FF5A00] to-[#FFD700] shadow-2xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-black/30 flex items-center justify-center text-2xl">
                {video.icon}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1 mb-0.5">
                  <Sparkle size={11} weight="fill" className="text-white" />
                  <p className="text-[10px] text-white/85 uppercase tracking-wider font-semibold">Zbulo</p>
                </div>
                <p className="text-sm font-bold text-white truncate">{video.title}</p>
                <p className="text-[11px] text-white/85 flex items-center gap-1">
                  <PlayCircle size={11} weight="fill" />{video.cta}
                </p>
              </div>
              <button onClick={(e) => { e.preventDefault(); setOpen(false); }}
                      className="w-7 h-7 rounded-lg bg-black/20 text-white shrink-0"
                      data-testid="edu-popup-close">
                <X size={14} className="mx-auto" weight="bold" />
              </button>
            </div>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
